import { IntegrationsActionTypes } from './action-types';
export const updateWordpressAuthResponse = wordpressAuthResponse => dispatch => {
  dispatch({
    type: IntegrationsActionTypes.UpdateWordpressAuthorizationResponseAction,
    wordpressAuthResponse
  });
};
export const setWordpressPermissions = valid => dispatch => {
  dispatch({
    type: IntegrationsActionTypes.SetWordpressPermissions,
    valid
  });
};
export const validateOAuthPermissions = () => dispatch => {
  dispatch({
    type: IntegrationsActionTypes.ValidateOAuthPermissions
  });
};
export const wordpressRedirect = ({
  queryParams,
  isNewPortal,
  isLoggedInIfNotExistingAccount,
  isntExistingAccount,
  hubId,
  hublet,
  signupBody,
  loginBody
}) => dispatch => {
  dispatch({
    type: IntegrationsActionTypes.WordPressRedirect,
    params: {
      queryParams,
      isNewPortal,
      isLoggedInIfNotExistingAccount,
      isntExistingAccount,
      hubId,
      hublet,
      signupBody,
      loginBody
    }
  });
};